<template>
  <div class="page-template">
    <div class="page-title">{{ title }}</div>
    <search-form-template
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
    >
    </search-form-template>
    <div class="page-title">{{ title1 }}</div>
    <list-template :tableOptions="tableOptions"> </list-template>
    <div class="page-title">{{ title2 }}</div>
    <list-operation
      ref="listOperation"
      :tableOptions="listColumns"
    ></list-operation>
    <el-dialog
      title="商品列表"
      :visible.sync="listShow"
      width="1200px"
      height="800"
      :close-on-click-modal="false"
    >
      <good-list
      :isSelect="true"
        @rowCheck="rowCheck"
        :tableOptions="showOptions"
        @selectSubmit="rowsSelectSubmit"
      ></good-list>
    </el-dialog>
  </div>
</template>

<script>
  import goodList from "@/components/business/goodList";
  import searchFormTemplate from "@/components/template/searchFormTemplate";
  import listTemplate from "@/components/template/listTemplate";
  import listOperation from "@/components/template/listOperation";
  import api from "@/config/api";

  export default {
  components: { searchFormTemplate, listTemplate, listOperation, goodList },
  data() {
    return {
      title: "",
      listShow: false,
      title1: "组合商品",
      title2: "成分商品",
      searchOptions: {
        simple: [
          {
            prop: "name",
            type: "input",
            isFuzzy: true,
            placeholder: "条码/商品名称",
          },
        ],
        complex: [
          {
            label: "查找选项：未定义成分商品",
            prop: "fdfhsrert",
            type: "switch",
          },
          {
            label: "商品类型：",
            type: "radio",
            prop: "updateGoods",
            span: 12,
            data: this.$utils.getCacheStatus("soBillOrder.orderType"),
          },
        ],
      },
      tableOptions: {
        showSelect:true,
        indexShow: true,
        columns: [
          { label: "商品类型", prop: "code", align: "center" },
          {label: "条码", prop: "name", align: "center"},
          { label: "商品名称", prop: "name", align: "center" },
          { label: "规格", prop: "name", align: "center" },
          { label: "单位", prop: "name", align: "center" },
          { label: "进货价", prop: "name", align: "center" },
          { label: "批发价", prop: "name", align: "center" },
          { label: "零售价", prop: "name", align: "center" },
        ],
      },
      toolConfig: [
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
        },
        {
          label: "刷新",
          code: "refresh",
           callback: this.refresh,
        },
        {
          label: "选择商品",
          code: "selectGoods",
           callback: this.checkGoods,
        },
        {
          label: "设置",
          code: "set",
        },
        {
          label: "导出",
          code: "export",
        },
      ],
          showOptions: {
        indexShow: true,//是否显示索引
        indexMethod: (index) => {//自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: '条码',
            prop: 'barCode',
            width: '200',
            align: 'center'
          },
          {
            label: "品名",
            prop: "goodsName",
            width: "120",
            align: "center"
          },
          {
            label: "规格",
            prop: "specs",
            width: "100",
            align: "center"
          },
          {
            label: '单位',
            prop: 'unitName',
            width: '100',
            align: 'center'
          },
          {
            label: '进货价',
            prop: 'buyPrice',
            width: '90',
            align: 'center'
          },
          {
            label: '批发价',
            prop: 'tradePrice',
            width: '90',
            align: 'center'
          },
          {
            label: '零售价',
            prop: 'retailPrice',
            width: '90',
            align: 'center'
          },
        ],
        url: api.archives.goodsInfoIncludeSpecs
      },
      checkIndex: "",
      listColumns: {
        // summaryColumns: ['goodsNum', 'salesAmount', 'totalPrice'],
        columns: [
          { label: "序号", type: "index", width: 100, prop: "idx" },
          { label: "操作", type: "operation", width: 160, prop: "operation" },
          {
            label: "条码",
            prop: "barCode",
            type: "more",
            callback: this.getInfo,
            width: "190",
          },
          {
            label: "商品名称",
            prop: "goodsName",
            width: "90",
          },
          {
            label: "规格",
            prop: "specs",
            width: "90",
          },
          {
            label: "单位",
            width: "90",
            prop: "unitName",
          },
          {
            label: "进货价",
            width: "90",
            prop: "artNo",
          },
          {
            label: "批发价",
            width: "100",
            prop: "retailPrice",
          },
          {
            label: "零售价",
            width: "90",
            prop: "salesAmount",
          },
          {
            label: "成分数量",
            width: "90",
            prop: "buyPrice",
            type: "inputNumber",
          },
          {
            label: "零售价",
            width: "120",
            prop: "goodsNum",
          },
        ],
      },
    };
  },
  mounted() {
    this.title = document.title;
  },
  methods: {
    checkGoods() {
      this.listShow = true;
    },
    refresh() {
      this.$router.go(0);
    },
    //选择某行数据
    rowCheck(row) {
      this.listShow = false;
      this.$refs["listOperation"].setColumnData(row, this.checkIndex);
    },
    rowsSelectSubmit(rows) {
      this.listShow = false;
    },
    getInfo(rowData, index) {
      this.listShow = true;
      this.checkIndex = index;
    },
  },
};
</script>

<style scoped>
>>> .el-form--inline .el-form-item__label {
  display: inline;
}
>>> .search-box .complex-box {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/page/weigh/speciality/Grading.vue